/**
 *
 * AddNewIconButton
 *
 */

import React from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

// icons
import { PlusOutlined } from '@ant-design/icons';

function AddNewIconButton({
  disabled,
  // actions
  onClick,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('add-new-icon-button', disabled && 'disabled', className);

  return (
    <span {...rest} className={childClassNames} onClick={onClick}>
      <PlusOutlined />
    </span>
  );
}

AddNewIconButton.defaultProps = {
  disabled: false
};

export default AddNewIconButton;
